var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandidatesIc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5447 17.3627V15.5446C15.5447 14.5802 15.1616 13.6554 14.4796 12.9735C13.7977 12.2916 12.8729 11.9084 11.9085 11.9084H4.63616C3.67179 11.9084 2.74692 12.2916 2.06501 12.9735C1.3831 13.6554 1 14.5802 1 15.5446V17.3627",
    stroke: "#64B5F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27336 8.27228C10.2816 8.27228 11.9095 6.64435 11.9095 4.63616C11.9095 2.62796 10.2816 1 8.27336 1C6.26517 1 4.63721 2.62796 4.63721 4.63616C4.63721 6.64435 6.26517 8.27228 8.27336 8.27228Z",
    stroke: "#64B5F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 17.3627V15.5446C20.9995 14.739 20.7313 13.9564 20.2377 13.3196C19.7441 12.6829 19.053 12.228 18.2729 12.0266",
    stroke: "#64B5F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6357 1.11816C15.4179 1.31843 16.1112 1.77331 16.6062 2.4111C17.1013 3.04888 17.37 3.83331 17.37 4.64068C17.37 5.44807 17.1013 6.23249 16.6062 6.87028C16.1112 7.50805 15.4179 7.96298 14.6357 8.16326",
    stroke: "#64B5F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidatesIc);
export default __webpack_public_path__ + "static/media/candidates-ic.aa2214a6c125dbf31a3a9e9c1cb4182f.svg";
export { ForwardRef as ReactComponent };